import { createFileRoute } from "@tanstack/react-router";
import Auth from "@/pages/Auth";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/auth/")({
  head: () => routeHead("/uk/auth/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Auth />
  );
}
